import { render, staticRenderFns } from "./AlertPopup.vue?vue&type=template&id=33bfdf88&scoped=true"
import script from "./AlertPopup.vue?vue&type=script&lang=js"
export * from "./AlertPopup.vue?vue&type=script&lang=js"
import style0 from "./AlertPopup.vue?vue&type=style&index=0&id=33bfdf88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bfdf88",
  null
  
)

export default component.exports